module.exports = __webpack_public_path__ + "static/media/naivna-pedagogika.50e9762c.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/exhibitors/naivna-pedagogika.png
// module id = 460
// module chunks = 0